<div
  tabindex="{{ index }}"
  class="a-chip"
  [class.-image]="imageSrc"
  [class.-btnClose]="removable"
  [class.-icon]="icon"
  [class.a-chip--fixed]="fixed"
  [class.-selected]="selected"
  [class.-disabled]="disabled"
  [attr.aria-labelledby]="id"
  role="button"
>
  @if(imageSrc){
  <div class="fixed-width-image-label-group">
    <ng-container *ngTemplateOutlet="chipTemplate"></ng-container>
  </div>
  } @else {
  <ng-container *ngTemplateOutlet="chipTemplate"></ng-container>
  }
</div>

<ng-template #chipTemplate>
  @if (icon) { <bosch-ui-icon [name]="icon"></bosch-ui-icon>} @if (imageSrc){
  <img class="a-chip__image" alt="ChipImage" width="24" height="24" src="{{ imageSrc }}" />
  }

  <span [id]="id" class="a-chip__label">
    <ng-content></ng-content>
  </span>
  @if (removable) { <bosch-ui-icon [name]="closeIcon" (click)="remove()"></bosch-ui-icon>}
</ng-template>
